import { UserInfo } from 'generated/graphql';

export const getIsCurrentUserCreatorOrEditorOfDashboard = (
  editors: UserInfo[],
  currentUserID: string,
  dashboardCreatorId: string,
) => {
  return (
    editors.some((editor) => editor.id === currentUserID) ||
    dashboardCreatorId === currentUserID
  );
};
